import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupExclude: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-exclude"><path fillRule="evenodd" clipRule="evenodd" d="M16 16H21C21.5523 16 22 15.5523 22 15V3C22 2.44772 21.5523 2 21 2H9C8.44772 2 8 2.44772 8 3V8H3C2.44772 8 2 8.44772 2 9V21C2 21.5523 2.44772 22 3 22H15C15.5523 22 16 21.5523 16 21V16ZM8 8H15C15.5523 8 16 8.44772 16 9V16H9C8.44772 16 8 15.5523 8 15V8Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBooleanGroupExclude;
